<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Home',
})
</script>
<template>
  <section class="Home">
  <!-- 1. 父容器 a-layout 设置为 flex 布局，并指定总高度 -->
  <a-layout :style="layoutStyle">
    
    <!-- 2. 顶部 Header 保持原有样式即可 -->
    <a-layout-header :style="headerStyle">
      <head-component  :user="userinfo"  />
    </a-layout-header>

    <!-- 3. 内容区设置 flex: 1 来占满剩余空间 -->
    <a-layout-content :style="contentStyle">
      <!-- 这里是你的主要内容 -->
      <!-- <div class="content-wrapper">
        <p>这里是页面的主要内容区域。</p>
        <p>它会自动填满除了头部以外的所有空间。</p>
      </div> -->
    </a-layout-content>

  </a-layout>

    <!-- <a-button type="primary" @click="systemConfig.commit(SET_TITLE, '124')">修改</a-button>  -->

  </section>
</template>

<script lang="ts" setup name="Home">
import { systemConfig } from '@/store/reactiveState'
import { SET_TITLE } from '@/store/mutation-types';
// 从ant-design-vue/es导入（4.x版本推荐的按需导入方式）
// import AButton from 'ant-design-vue/es/button';
// import ARow from 'ant-design-vue/es/row';
// import ACol from 'ant-design-vue/es/col';
import ALayout from 'ant-design-vue/es/layout';
import type { CSSProperties } from 'vue';
// import { UploadOutlined } from '@ant-design/icons-vue';
import HeadComponent from './components/Head.vue'; // 导入组件
import ls from '@/utils/Storage'
import { USER_INFO } from '@/store/mutation-types'

const userinfo = ls.get(USER_INFO)
const headerStyle: CSSProperties = {
  // textAlign: 'center',
  // color: '#fff',
  // // height: 32,
  height: '45px',
  paddingInline: 0, // 注释或删除这一行
  // // lineHeight: '30px',
  // backgroundColor: '#7dbcea',
};

const contentStyle: CSSProperties = {
  textAlign: 'center',
  minHeight: 120,
  lineHeight: '120px',
  color: '#fff',
  // backgroundColor: '#108ee9',
};
const layoutStyle: CSSProperties = {
  display: 'flex',         // 关键：启用 flex 布局
  flexDirection: 'column', // 关键：子元素垂直排列
  height: '100vh',         // 关键：设置容器高度为整个视口高度
  backgroundColor: '#fff',
};

</script>

<style scoped lang="less">
.Home {
  height: 100vh;
  padding: 0px;
}

:deep(.ant-row) {
  background: #f0f2f5;
  padding: 10px 0;
}

:deep(.ant-col) {
  background: #e6f7ff;
  padding: 10px;
  border: 1px solid #91d5ff;
  text-align: center;
}

:deep(.ant-btn) {
  // 取消注释下面这行可以全局设置
  border-radius: 6px !important;
}

</style>
